import createClass from 'create-react-class'
import React from 'react'
import { FormCheckbox } from 'live/components/forms/ui/form-checkbox'
import Select from 'react-select'
import styled from 'styled-components'
import CodeMirror from 'live/components/codemirror/codemirror'
import { Panel, PanelGroup } from 'react-bootstrap'
import TableForm from 'live/components/forms/ui/table-form'
import i18n from 'live/services/i18n'
import FormBase from 'live/components/extensions/ui/form'
import FormGroup from 'live/components/forms/ui/form-group'
import ValidationMixin from 'live/components/forms/mixins/validation-mixin'
import ObjectInitializerMixinFactory from 'live/components/forms/mixins/object-initializer'
import TableFormSpanComponent from './components/TableFormSpanComponent'
import LiveTooltip from 'live/components/ui/tooltip'

const ObjectInitializerMixin = ObjectInitializerMixinFactory('/rest/extension', {
    type: 'plugin-asset-metadata',
    active: true,
    config: {
        integrationSystem: 'PXDRest',

        edmDBType: 'Oracle',
        edmConnectionString: '',
        edmSQLUsername: '',
        edmSQLPassword: '',

        pxdRestAPIUrl: '',
        pxdUsername: '',
        pxdPassword: '',

        pullActiveWells: false,
        wellsSchedule: 30,
        maxWellCount: 30,
        pullCompleteWells: false,
        startDelay: 0,
        limitToWells: '.+',

        applyDescription: true,
        applyLocation: true,
        applySections: false,
        applyPressures: true,
        applyPlannedTrajectory: false,
        applyFormation: true,
        applyActualTrajectory: false,
        applyDrillingSections: false,
        applyOpenHole: false,
        applyLastCasing: false,
        applyLiner: false,
        applyDrillingRuns: false,
        applyDrillingOperations: false,
        applyDrillStrings: false,
        applyBHAs: false,
        applyDrillingFluids: false,
        applyCasingRuns: false,
        applyCasingOperations: false,
        applyWorkColumns: false,
        applyCasings: false,
        applyCasingFluids: false,

        overrideDrillingSectionsQuery: false,
        customDrillingSectionsQuery: '',
        overrideRunsQuery: false,
        customRunsQuery: '',
        overrideLastCasingQuery: false,
        customLastCasingQuery: '',
        overrideOpenHoleQuery: false,
        customOpenHoleQuery: '',
        overrideLinerQuery: false,
        customLinerQuery: '',
        overrideOperationsQuery: false,
        customOperationsQuery: '',
        overrideDrillStringQuery: false,
        customDrillStringQuery: '',
        overrideBHAQuery: false,
        customBHAQuery: '',
        overrideFluidsQuery: false,
        customFluidsQuery: '',
        overrideCasingOperationsQuery: false,
        customCasingOperationsQuery: '',
        overrideCasingsQuery: '',
        customCasingsQuery: '',
        overrideWorkColumnsQuery: false,
        customWorkColumnsQuery: '',
        overrideCasingFluidsQuery: false,
        customCasingFluidsQuery: '',

        homeDashboards: [],
        domDashboards: [],
        projectDashboards: [],
        siteDashboards: [],
        rigDashboards: [],
        wellDashboards: [],
        wellboreDashboards: [],
        sectionDashboards: [],

        timeSpanPreset: 'last 24 hours',
        pullLastTimeStampFromEvents: false,
        depthSpanPreset: 'last 1000 ft',
        dashboardCategorySortOrder: 'Time Dashboards,Depth Dashboards',

        edmExpireAfterAccess: 60,
        edmMaximumCacheSize: 1500,

        edmTimeout: 5,
        dbPoolSize: 10,
        maxLifeTime: 1800000,

        timezoneOffset: 0,
        corePoolSize: 10,
        maximumPoolSize: 50,
        manageChangeLog: false,
        useInterventionSections: false
    },
    fullQualifier: '',
    qualifier: '',
    status: {}
})

const Form = createClass({
    mixins: [ObjectInitializerMixin, ValidationMixin],
    validations: {
        properties: {
            config: {
                properties: {}
            }
        }
    },
    onChangeCheckbox: function (e) {
        const object = this.state.object
        const config = object.config
        const field = e.target.name
        config[field] = !config[field]
        this.applyObj({
            config: config
        })
        this.handleValidation(e)
    },
    /* TODO: Fix Select */
    onSelect: function (e) {
        const object = this.state.object
        const config = object.config

        if (config.integrationSystem !== e.value) {
            config.integrationSystem = e.value
            this.applyObj({
                config: config
            })
        }
    },
    onSelectDBType: function (e) {
        const object = this.state.object
        const config = object.config
        if (config.edmDBType !== e.value) {
            config.edmDBType = e.value
            this.applyObj({
                config: config
            })
        }
    },
    getValue: function (getFrom, alternateVal) {
        if (getFrom === null || getFrom === undefined || getFrom.length === 0) {
            return alternateVal
        } else {
            return getFrom
        }
    },
    splitAndGetTimePresetValue(span: string) {
        const splitSpan = span.split(' ')
        const adjective = splitSpan.length > 0 ? splitSpan[0] : ''
        const value = splitSpan.length > 1 ? splitSpan[1] : ''
        const unit = splitSpan.length > 2 ? splitSpan[2] : ''
        const anchor = splitSpan.length > 3 ? splitSpan[3] : ''
        const anchorTime = splitSpan.length > 4 ? splitSpan[4] : ''

        return {
            span: adjective && value && unit ? adjective + ' ' + value + ' ' + unit : '',
            anchor: anchor && anchorTime && anchorTime.length > 0 && anchor.length > 0 ? anchorTime : ''
        }
    },

    getSpanAndAnchorValueForSpan(span: string, anchorTime: string, spanType: string) {
        if (span && anchorTime && span.length > 0 && anchorTime.length > 0 && spanType === 'Time') {
            return span + ' anchorTime ' + anchorTime
        } else if (span && span.length > 0) {
            return span
        } else {
            return ''
        }
    },
    getDashboardCategories(categories: string) {
        if (categories && categories.length > 0) {
            let splitCat = categories.split(',')
            var obj = []
            splitCat.forEach(name => {
                obj.push({
                    value: name.trim(),
                    label: name.trim()
                })
            })
            return obj
        } else {
            return [
                { value: 'Time Dashboards', label: 'Time Dashboards' },
                { value: 'Depth Dashboards', label: 'Depth Dashboards' }
            ]
        }
    },

    render: function () {
        const object = this.state.object
        const config = object.config
        const options = [
            { value: 'ADNOCEDM', label: 'ADNOC - EDM' },
            { value: 'PXDREST', label: 'PXD - WellView Rest' }
        ]
        const dbTypeOptions = [
            { value: 'Oracle', label: 'Oracle' },
            { value: 'MySQL', label: 'MySQL / MariaDB' },
            { value: 'SQLServer', label: 'Microsoft SQL Server' }
        ]

        return (
            <FormBase self={this}>
                <div className="form-control">
                    <h3>{i18n('Data Connector Type')}</h3>
                    <Select value={config.integrationSystem} options={options} onChange={this.onSelect} />
                    <br />
                    <PanelGroup accordion id="accordion-uncontrolled">
                        <Panel eventKey="1">
                            <Panel.Heading>
                                <Panel.Title toggle>
                                    <h3>Metadata System Connection Settings</h3>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible>
                                {config.integrationSystem === 'PXDREST' && (
                                    <div>
                                        <h3>{i18n('PXD Rest API Settings')}</h3>
                                        <FormGroup
                                            type="text"
                                            label={
                                                <span>
                                                    {' '}
                                                    {i18n('API URL')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.pxdRestAPIUrl"
                                            value={config.pxdRestAPIUrl}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.pxdRestAPIUrl')}
                                            hasFeedback
                                            help={this.errorsFor('config.pxdRestAPIUrl')}
                                        />
                                        <FormGroup
                                            type="text"
                                            label={
                                                <span>
                                                    {' '}
                                                    {i18n('UserName')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.pxdUsername"
                                            value={config.pxdUsername}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.pxdUsername')}
                                            hasFeedback
                                            help={this.errorsFor('config.pxdUsername')}
                                        />
                                        <FormGroup
                                            type="password"
                                            label={
                                                <span>
                                                    {' '}
                                                    {i18n('Password')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.pxdPassword"
                                            value={config.pxdPassword}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.pxdPassword')}
                                            hasFeedback
                                            help={this.errorsFor('config.pxdPassword')}
                                        />
                                    </div>
                                )}
                                {config.integrationSystem === 'ADNOCEDM' && (
                                    <div>
                                        <h3>{i18n('ADNOC EDM DB Settings')}</h3>
                                        <h4>{i18n('Database Type')}</h4>
                                        <Select
                                            value={config.edmDBType}
                                            options={dbTypeOptions}
                                            onChange={this.onSelectDBType}
                                        />
                                        <br />
                                        <FormGroup
                                            type="text"
                                            label={
                                                <span>
                                                    {' '}
                                                    {i18n('Database Connection String')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.edmConnectionString"
                                            value={config.edmConnectionString}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.edmConnectionString')}
                                            hasFeedback
                                            help={this.errorsFor('config.edmConnectionString')}
                                        />
                                        <FormGroup
                                            type="text"
                                            label={
                                                <span>
                                                    {' '}
                                                    {i18n('User Name')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.edmSQLUsername"
                                            value={config.edmSQLUsername}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.edmSQLUsername')}
                                            hasFeedback
                                            help={this.errorsFor('config.edmSQLUsername')}
                                        />
                                        <FormGroup
                                            type="password"
                                            label={
                                                <span>
                                                    {' '}
                                                    {i18n('Password')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.edmSQLPassword"
                                            value={config.edmSQLPassword}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.edmSQLPassword')}
                                            hasFeedback
                                            help={this.errorsFor('config.edmSQLPassword')}
                                        />
                                        <FormGroup
                                            type="text"
                                            label={
                                                <span>
                                                    {' '}
                                                    {i18n('Database Connection Timeout')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.edmTimeout"
                                            value={config.edmTimeout}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.edmTimeout')}
                                            hasFeedback
                                            help={this.errorsFor('config.edmTimeout')}
                                        />
                                        <FormGroup
                                            type="text"
                                            label={
                                                <span>
                                                    {' '}
                                                    {i18n('Database Connection Pool Size')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.dbPoolSize"
                                            value={config.dbPoolSize}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.dbPoolSize')}
                                            hasFeedback
                                            help={this.errorsFor('config.dbPoolSize')}
                                        />
                                        <FormGroup
                                            type="text"
                                            label={
                                                <span>
                                                    {' '}
                                                    {i18n('Connection Maximum Life Time')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.maxLifeTime"
                                            value={config.maxLifeTime}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.maxLifeTime')}
                                            hasFeedback
                                            help={this.errorsFor('config.maxLifeTime')}
                                        />
                                    </div>
                                )}
                            </Panel.Body>
                        </Panel>
                        <Panel eventKey="2">
                            <Panel.Heading>
                                <Panel.Title toggle>
                                    <h3>Work Flow Settings</h3>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible>
                                <div>
                                    <FormCheckbox
                                        name="pullActiveWells"
                                        checked={
                                            typeof config.pullActiveWells !== 'undefined'
                                                ? config.pullActiveWells
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Pull Active Wells')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <FormCheckbox
                                        name="pullCompleteWells"
                                        checked={
                                            typeof config.pullCompleteWells !== 'undefined'
                                                ? config.pullCompleteWells
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Pull Complete Wells')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <div>
                                        <FormGroup
                                            type="text"
                                            label={
                                                <span>
                                                    {' '}
                                                    {i18n('Refresh Interval (minutes)')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.wellsSchedule"
                                            value={config.wellsSchedule}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.wellsSchedule')}
                                            hasFeedback
                                            help={this.errorsFor('config.wellsSchedule')}
                                        />
                                        <FormGroup
                                            type="text"
                                            label={
                                                <span>
                                                    {' '}
                                                    {i18n('Max Well Count')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.maxWellCount"
                                            value={config.maxWellCount}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.maxWellCount')}
                                            hasFeedback
                                            help={this.errorsFor('config.maxWellCount')}
                                        />
                                        <FormGroup
                                            type="text"
                                            label={
                                                <span>
                                                    {' '}
                                                    {i18n('Start Delay')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.startDelay"
                                            value={config.startDelay}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.startDelay')}
                                            hasFeedback
                                            help={this.errorsFor('config.startDelay')}
                                        />
                                        <FormGroup
                                            type="text"
                                            label={
                                                <span>
                                                    {' '}
                                                    {i18n('Limit Wells to Regex')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.limitToWells"
                                            value={config.limitToWells}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.limitToWells')}
                                            hasFeedback
                                            help={this.errorsFor('config.limitToWells')}
                                        />
                                    </div>
                                </div>
                            </Panel.Body>
                        </Panel>
                        <Panel eventKey="3">
                            <Panel.Heading>
                                <Panel.Title toggle>
                                    <h3>Navigation Dashboards</h3>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible>
                                <div>
                                    <h4>{i18n('Dashboard Time/Depth Span Presets')}</h4>
                                    <FormGroup
                                        type="text"
                                        label={
                                            <span>
                                                {' '}
                                                {i18n('Time Span Preset')}
                                                <abbr title="required">*</abbr>
                                            </span>
                                        }
                                        name="config.timeSpanPreset"
                                        value={config.timeSpanPreset}
                                        onChange={this.handleValidation}
                                        validationState={this.validationState('config.timeSpanPreset')}
                                        hasFeedback
                                        help={this.errorsFor('config.timeSpanPreset')}
                                    />
                                    <FormCheckbox
                                        name="pullLastTimeStampFromEvents"
                                        checked={
                                            typeof config.pullLastTimeStampFromEvents !== 'undefined'
                                                ? config.pullLastTimeStampFromEvents
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Get RT Time from Events')}
                                        disabled={undefined}
                                        note={
                                            '(If unchecked then the recent time for a well will be selected from Intervention. Applicable only to Active Wells. Recommended to uncheck this by default)'
                                        }
                                    />
                                    <FormGroup
                                        type="text"
                                        label={
                                            <span>
                                                {' '}
                                                {i18n('Depth Span Preset')}
                                                <abbr title="required">*</abbr>
                                            </span>
                                        }
                                        name="config.depthSpanPreset"
                                        value={config.depthSpanPreset}
                                        onChange={this.handleValidation}
                                        validationState={this.validationState('config.depthSpanPreset')}
                                        hasFeedback
                                        help={this.errorsFor('config.depthSpanPreset')}
                                    />
                                </div>
                                <div>
                                    <h4>{i18n('Dashboard Category Sort Order')}</h4>
                                    <FormGroup
                                        type="text"
                                        label={
                                            <span>
                                                {' '}
                                                {i18n('Sort Order (seperated by Comma)')}
                                                <abbr title="required">*</abbr>
                                            </span>
                                        }
                                        name="config.dashboardCategorySortOrder"
                                        value={config.dashboardCategorySortOrder}
                                        onChange={this.handleValidation}
                                        validationState={this.validationState('config.dashboardCategorySortOrder')}
                                        hasFeedback
                                        help={this.errorsFor('config.dashboardCategorySortOrder')}
                                    />
                                </div>
                                <div>
                                    <h4>{i18n('Dashboards')}</h4>
                                    <h5>
                                        {i18n('Column Headers : Dasboard Index Type ')}
                                        <LiveTooltip
                                            position={'left'}
                                            content={i18n('Determines the main index of the dashboard')}
                                        >
                                            <i className="fa fa-question-circle-o"></i>
                                        </LiveTooltip>
                                        {i18n(', Dasboard Name ')}
                                        <LiveTooltip
                                            position={'left'}
                                            content={i18n('Name of the dashboard as per the way it was uploaded')}
                                        >
                                            <i className="fa fa-question-circle-o"></i>
                                        </LiveTooltip>
                                        {i18n(', Span preset override ')}
                                        <LiveTooltip
                                            position={'left'}
                                            content={i18n(
                                                'Overrides the overall span preset value so that dsahboard specific values can be provided'
                                            )}
                                        >
                                            <i className="fa fa-question-circle-o"></i>
                                        </LiveTooltip>
                                        {i18n(', Dashboard specific preset value ')}
                                        <LiveTooltip
                                            position={'left'}
                                            content={i18n(
                                                'Dashboard specific span value (Enabled only when "Override Span Preset" is checked). Possible values are last XXXX hours/days/mins/seconds or last XXXX ft/m'
                                            )}
                                        >
                                            <i className="fa fa-question-circle-o"></i>
                                        </LiveTooltip>
                                        {i18n(', Dashboard specific anchor time ')}
                                        <LiveTooltip
                                            position={'left'}
                                            content={i18n(
                                                'Option to override the time component of the span with the time entered here. HH:mm:ss is the expected format'
                                            )}
                                        >
                                            <i className="fa fa-question-circle-o"></i>
                                        </LiveTooltip>
                                        {i18n(' and Dashboard Category ')}
                                        <LiveTooltip
                                            position={'left'}
                                            content={i18n(
                                                'Category of the dashboard with which the data is dashboards are grouped in the navigation tree'
                                            )}
                                        >
                                            <i className="fa fa-question-circle-o"></i>
                                        </LiveTooltip>
                                    </h5>
                                    {[
                                        ['homeDashboards', 'Home Dashboards'],
                                        ['domDashboards', 'DOM Dashboards'],
                                        ['projectDashboards', 'Project Dashboards'],
                                        ['siteDashboards', 'Site Dashboards'],
                                        ['rigDashboards', 'Rig Dashboards'],
                                        ['wellDashboards', 'Well Dashboards'],
                                        ['wellboreDashboards', 'Wellbore Dashboards'],
                                        ['sectionDashboards', 'Section Dashboards']
                                    ].map(dashboardType => {
                                        return (
                                            <StyledTableFormContainer>
                                                <TableForm
                                                    addButtonLabel={'+ Add Dashboard'}
                                                    visibleRows={0}
                                                    fields={[
                                                        {
                                                            label: dashboardType[1],
                                                            name: 'dashboard',
                                                            type: 'component',
                                                            Component: TableFormSpanComponent
                                                        }
                                                    ]}
                                                    data={config[dashboardType[0]]?.map((cnfg, index) => ({
                                                        dashboard: cnfg?.dashboard,
                                                        overridePreset: cnfg?.overridePreset,
                                                        spanType: cnfg?.spanType,
                                                        spanPresetValue: this.splitAndGetTimePresetValue(
                                                            cnfg?.spanPresetValue
                                                        ).span,
                                                        spanPresetAnchor: this.splitAndGetTimePresetValue(
                                                            cnfg?.spanPresetValue
                                                        ).anchor,
                                                        dashboardCategory: cnfg?.dashboardCategory,
                                                        showAllDataIfCompleted: cnfg?.showAllDataIfCompleted,
                                                        timeSpanPreset: config.timeSpanPreset,
                                                        depthSpanPreset: config.depthSpanPreset,
                                                        dashboardCategoriesList: this.getDashboardCategories(
                                                            config?.dashboardCategorySortOrder
                                                        ),
                                                        showActiveOverrideFunction: dashboardType[1].includes(
                                                            'Section'
                                                        ),
                                                        index: index
                                                    }))}
                                                    onChange={e => {
                                                        config[dashboardType[0]] = e
                                                            .filter(cnfg => cnfg !== null && cnfg.dashboard !== null)
                                                            .map(cnfg => {
                                                                return {
                                                                    dashboard: this.getValue(cnfg.dashboard, ''),
                                                                    showAllDataIfCompleted: this.getValue(
                                                                        cnfg.showAllDataIfCompleted,
                                                                        false
                                                                    ),
                                                                    overridePreset: this.getValue(
                                                                        cnfg.overridePreset,
                                                                        false
                                                                    ),
                                                                    spanType: this.getValue(cnfg.spanType, 'Time'),
                                                                    dashboardCategory: this.getValue(
                                                                        cnfg.dashboardCategory,
                                                                        this.getValue(cnfg.spanType, 'Time') +
                                                                            ' Dashboards'
                                                                    ),
                                                                    spanPresetValue: this.getValue(
                                                                        cnfg.overridePreset,
                                                                        false
                                                                    )
                                                                        ? this.getSpanAndAnchorValueForSpan(
                                                                              this.getValue(cnfg.spanPresetValue),
                                                                              this.getValue(cnfg.spanPresetAnchor),
                                                                              this.getValue(cnfg.spanType, 'Time')
                                                                          )
                                                                        : ''
                                                                }
                                                            })
                                                    }}
                                                />
                                                <hr />
                                            </StyledTableFormContainer>
                                        )
                                    })}
                                </div>
                            </Panel.Body>
                        </Panel>
                        <Panel eventKey="4">
                            <Panel.Heading>
                                <Panel.Title toggle>
                                    <h3>Well Parameters and Intervention Update Settings</h3>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible>
                                <div>
                                    <FormCheckbox
                                        name="applyDescription"
                                        checked={
                                            typeof config.applyDescription !== 'undefined'
                                                ? config.applyDescription
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Apply Description')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <FormCheckbox
                                        name="applyLocation"
                                        checked={
                                            typeof config.applyLocation !== 'undefined' ? config.applyLocation : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Apply Location')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <FormCheckbox
                                        name="applySections"
                                        checked={
                                            typeof config.applySections !== 'undefined' ? config.applySections : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Apply Sections')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <FormCheckbox
                                        name="applyPressures"
                                        checked={
                                            typeof config.applyPressures !== 'undefined' ? config.applyPressures : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Apply Pressures')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <FormCheckbox
                                        name="applyPlannedTrajectory"
                                        checked={
                                            typeof config.applyPlannedTrajectory !== 'undefined'
                                                ? config.applyPlannedTrajectory
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Apply Planned Trajectory')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <FormCheckbox
                                        name="applyFormation"
                                        checked={
                                            typeof config.applyFormation !== 'undefined' ? config.applyFormation : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Apply Formation')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <FormCheckbox
                                        name="applyActualTrajectory"
                                        checked={
                                            typeof config.applyActualTrajectory !== 'undefined'
                                                ? config.applyActualTrajectory
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Apply Actual Trajectory')}
                                        disabled={undefined}
                                        note={undefined}
                                    />

                                    <FormCheckbox
                                        name="applyDrillingSections"
                                        checked={
                                            typeof config.applyDrillingSections !== 'undefined'
                                                ? config.applyDrillingSections
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Apply Drilling Sections')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <FormCheckbox
                                        name="applyOpenHole"
                                        checked={
                                            typeof config.applyOpenHole !== 'undefined' ? config.applyOpenHole : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Apply Open Hole')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <FormCheckbox
                                        name="applyLiner"
                                        checked={typeof config.applyLiner !== 'undefined' ? config.applyLiner : false}
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Apply Liner')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <FormCheckbox
                                        name="applyLastCasing"
                                        checked={
                                            typeof config.applyLastCasing !== 'undefined'
                                                ? config.applyLastCasing
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Apply Last Casing')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <FormCheckbox
                                        name="applyDrillingRuns"
                                        checked={
                                            typeof config.applyDrillingRuns !== 'undefined'
                                                ? config.applyDrillingRuns
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Apply Drilling Runs')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <FormCheckbox
                                        name="applyDrillingOperations"
                                        checked={
                                            typeof config.applyDrillingOperations !== 'undefined'
                                                ? config.applyDrillingOperations
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Apply Drilling Operations')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <FormCheckbox
                                        name="applyDrillStrings"
                                        checked={
                                            typeof config.applyDrillStrings !== 'undefined'
                                                ? config.applyDrillStrings
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Apply Drilling Strings')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <FormCheckbox
                                        name="applyBHAs"
                                        checked={typeof config.applyBHAs !== 'undefined' ? config.applyBHAs : false}
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Apply BHAs')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <FormCheckbox
                                        name="applyDrillingFluids"
                                        checked={
                                            typeof config.applyDrillingFluids !== 'undefined'
                                                ? config.applyDrillingFluids
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Apply Drilling Fluids')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <FormCheckbox
                                        name="applyCasingRuns"
                                        checked={
                                            typeof config.applyCasingRuns !== 'undefined'
                                                ? config.applyCasingRuns
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Apply Casing Runs')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <FormCheckbox
                                        name="applyCasingOperations"
                                        checked={
                                            typeof config.applyCasingOperations !== 'undefined'
                                                ? config.applyCasingOperations
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Apply Casing Operations')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <FormCheckbox
                                        name="applyWorkColumns"
                                        checked={
                                            typeof config.applyWorkColumns !== 'undefined'
                                                ? config.applyWorkColumns
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Apply Work Columns')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <FormCheckbox
                                        name="applyCasings"
                                        checked={
                                            typeof config.applyCasings !== 'undefined' ? config.applyCasings : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Apply Casings')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <FormCheckbox
                                        name="applyCasingFluids"
                                        checked={
                                            typeof config.applyCasingFluids !== 'undefined'
                                                ? config.applyCasingFluids
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Apply Casing Fluids')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                </div>
                            </Panel.Body>
                        </Panel>
                        <Panel eventKey="5">
                            <Panel.Heading>
                                <Panel.Title toggle>
                                    <h3>Override Intervention Queries</h3>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible>
                                <div>
                                    <h4>{i18n('Drilling Sections Settings')}</h4>
                                    <FormCheckbox
                                        name="overrideDrillingSectionsQuery"
                                        checked={
                                            typeof config.overrideDrillingSectionsQuery !== 'undefined'
                                                ? config.overrideDrillingSectionsQuery
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Override Drilling Sections Query')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    {config.overrideDrillingSectionsQuery && (
                                        <div>
                                            <CodeMirror
                                                id="config.customDrillingSectionsQuery"
                                                value={config.customDrillingSectionsQuery}
                                                onChange={value =>
                                                    this.handleValidation({
                                                        target: {
                                                            value,
                                                            name: 'config.customDrillingSectionsQuery'
                                                        }
                                                    })
                                                }
                                                options={{
                                                    mode: 'pipes',
                                                    matchBrackets: true,
                                                    lineNumbers: true,
                                                    foldGutter: true
                                                }}
                                            />
                                        </div>
                                    )}
                                    <FormCheckbox
                                        name="overrideOpenHoleQuery"
                                        checked={
                                            typeof config.overrideOpenHoleQuery !== 'undefined'
                                                ? config.overrideOpenHoleQuery
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Override Open Hole Query')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    {config.overrideOpenHoleQuery && (
                                        <div>
                                            <CodeMirror
                                                id="config.customOpenHoleQuery"
                                                value={config.customOpenHoleQuery}
                                                onChange={value =>
                                                    this.handleValidation({
                                                        target: {
                                                            value,
                                                            name: 'config.customOpenHoleQuery'
                                                        }
                                                    })
                                                }
                                                options={{
                                                    mode: 'pipes',
                                                    matchBrackets: true,
                                                    lineNumbers: true,
                                                    foldGutter: true
                                                }}
                                            />
                                        </div>
                                    )}
                                    <FormCheckbox
                                        name="overrideLastCasingQuery"
                                        checked={
                                            typeof config.overrideLastCasingQuery !== 'undefined'
                                                ? config.overrideLastCasingQuery
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Override Last Casing Query')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    {config.overrideLastCasingQuery && (
                                        <div>
                                            <CodeMirror
                                                id="config.customLastCasingQuery"
                                                value={config.customLastCasingQuery}
                                                onChange={value =>
                                                    this.handleValidation({
                                                        target: {
                                                            value,
                                                            name: 'config.customLastCasingQuery'
                                                        }
                                                    })
                                                }
                                                options={{
                                                    mode: 'pipes',
                                                    matchBrackets: true,
                                                    lineNumbers: true,
                                                    foldGutter: true
                                                }}
                                            />
                                        </div>
                                    )}
                                    <FormCheckbox
                                        name="overrideLinerQuery"
                                        checked={
                                            typeof config.overrideLinerQuery !== 'undefined'
                                                ? config.overrideLinerQuery
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Override Liner Query')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    {config.overrideLinerQuery && (
                                        <div>
                                            <CodeMirror
                                                id="config.customLinerQuery"
                                                value={config.customLinerQuery}
                                                onChange={value =>
                                                    this.handleValidation({
                                                        target: {
                                                            value,
                                                            name: 'config.customLinerQuery'
                                                        }
                                                    })
                                                }
                                                options={{
                                                    mode: 'pipes',
                                                    matchBrackets: true,
                                                    lineNumbers: true,
                                                    foldGutter: true
                                                }}
                                            />
                                        </div>
                                    )}
                                    <hr />
                                    <h4>{i18n('Drilling Runs Settings')}</h4>
                                    <FormCheckbox
                                        name="overrideRunsQuery"
                                        checked={
                                            typeof config.overrideRunsQuery !== 'undefined'
                                                ? config.overrideRunsQuery
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Override Runs Query')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    {config.overrideRunsQuery && (
                                        <div>
                                            <CodeMirror
                                                id="config.customRunsQuery"
                                                value={config.customRunsQuery}
                                                onChange={value =>
                                                    this.handleValidation({
                                                        target: {
                                                            value,
                                                            name: 'config.customRunsQuery'
                                                        }
                                                    })
                                                }
                                                options={{
                                                    mode: 'pipes',
                                                    matchBrackets: true,
                                                    lineNumbers: true,
                                                    foldGutter: true
                                                }}
                                            />
                                        </div>
                                    )}
                                    <FormCheckbox
                                        name="overrideOperationsQuery"
                                        checked={
                                            typeof config.overrideOperationsQuery !== 'undefined'
                                                ? config.overrideOperationsQuery
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Override Operations Query')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    {config.overrideOperationsQuery && (
                                        <div>
                                            <CodeMirror
                                                id="config.customOperationsQuery"
                                                value={config.customOperationsQuery}
                                                onChange={value =>
                                                    this.handleValidation({
                                                        target: {
                                                            value,
                                                            name: 'config.customOperationsQuery'
                                                        }
                                                    })
                                                }
                                                options={{
                                                    mode: 'pipes',
                                                    matchBrackets: true,
                                                    lineNumbers: true,
                                                    foldGutter: true
                                                }}
                                            />
                                        </div>
                                    )}
                                    <FormCheckbox
                                        name="overrideDrillStringQuery"
                                        checked={
                                            typeof config.overrideDrillStringQuery !== 'undefined'
                                                ? config.overrideDrillStringQuery
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Override DrillString Query')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    {config.overrideDrillStringQuery && (
                                        <div>
                                            <CodeMirror
                                                id="config.customDrillStringQuery"
                                                value={config.customDrillStringQuery}
                                                onChange={value =>
                                                    this.handleValidation({
                                                        target: {
                                                            value,
                                                            name: 'config.customDrillStringQuery'
                                                        }
                                                    })
                                                }
                                                options={{
                                                    mode: 'pipes',
                                                    matchBrackets: true,
                                                    lineNumbers: true,
                                                    foldGutter: true
                                                }}
                                            />
                                        </div>
                                    )}
                                    <FormCheckbox
                                        name="overrideBHAQuery"
                                        checked={
                                            typeof config.overrideBHAQuery !== 'undefined'
                                                ? config.overrideBHAQuery
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Override BHA Query')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    {config.overrideBHAQuery && (
                                        <div>
                                            <CodeMirror
                                                id="config.customBHAQuery"
                                                value={config.customBHAQuery}
                                                onChange={value =>
                                                    this.handleValidation({
                                                        target: {
                                                            value,
                                                            name: 'config.customBHAQuery'
                                                        }
                                                    })
                                                }
                                                options={{
                                                    mode: 'pipes',
                                                    matchBrackets: true,
                                                    lineNumbers: true,
                                                    foldGutter: true
                                                }}
                                            />
                                        </div>
                                    )}
                                    <FormCheckbox
                                        name="overrideFluidsQuery"
                                        checked={
                                            typeof config.overrideFluidsQuery !== 'undefined'
                                                ? config.overrideFluidsQuery
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Override Fluids/Mucheck Query')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    {config.overrideFluidsQuery && (
                                        <div>
                                            <CodeMirror
                                                id="config.customFluidsQuery"
                                                value={config.customFluidsQuery}
                                                onChange={value =>
                                                    this.handleValidation({
                                                        target: {
                                                            value,
                                                            name: 'config.customFluidsQuery'
                                                        }
                                                    })
                                                }
                                                options={{
                                                    mode: 'pipes',
                                                    matchBrackets: true,
                                                    lineNumbers: true,
                                                    foldGutter: true
                                                }}
                                            />
                                        </div>
                                    )}
                                    <hr />
                                    <h4>{i18n('Casing Sections Settings')}</h4>
                                    <FormCheckbox
                                        name="overrideCasingRunsQuery"
                                        checked={
                                            typeof config.overrideCasingRunsQuery !== 'undefined'
                                                ? config.overrideCasingRunsQuery
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Override Casing Runs Query')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    {config.overrideCasingRunsQuery && (
                                        <div>
                                            <CodeMirror
                                                id="config.customCasingRunsQuery"
                                                value={config.customCasingRunsQuery}
                                                onChange={value =>
                                                    this.handleValidation({
                                                        target: {
                                                            value,
                                                            name: 'config.customCasingRunsQuery'
                                                        }
                                                    })
                                                }
                                                options={{
                                                    mode: 'pipes',
                                                    matchBrackets: true,
                                                    lineNumbers: true,
                                                    foldGutter: true
                                                }}
                                            />
                                        </div>
                                    )}
                                    <FormCheckbox
                                        name="overrideCasingOperationsQuery"
                                        checked={
                                            typeof config.overrideCasingOperationsQuery !== 'undefined'
                                                ? config.overrideCasingOperationsQuery
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Override Casing Operations Query')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    {config.overrideCasingOperationsQuery && (
                                        <div>
                                            <CodeMirror
                                                id="config.customCasingOperationsQuery"
                                                value={config.customCasingOperationsQuery}
                                                onChange={value =>
                                                    this.handleValidation({
                                                        target: {
                                                            value,
                                                            name: 'config.customCasingOperationsQuery'
                                                        }
                                                    })
                                                }
                                                options={{
                                                    mode: 'pipes',
                                                    matchBrackets: true,
                                                    lineNumbers: true,
                                                    foldGutter: true
                                                }}
                                            />
                                        </div>
                                    )}
                                    <FormCheckbox
                                        name="overrideCasingsQuery"
                                        checked={
                                            typeof config.overrideCasingsQuery !== 'undefined'
                                                ? config.overrideCasingsQuery
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Override Casings Query')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    {config.overrideCasingsQuery && (
                                        <div>
                                            <CodeMirror
                                                id="config.customCasingsQuery"
                                                value={config.customCasingsQuery}
                                                onChange={value =>
                                                    this.handleValidation({
                                                        target: {
                                                            value,
                                                            name: 'config.customCasingsQuery'
                                                        }
                                                    })
                                                }
                                                options={{
                                                    mode: 'pipes',
                                                    matchBrackets: true,
                                                    lineNumbers: true,
                                                    foldGutter: true
                                                }}
                                            />
                                        </div>
                                    )}
                                    <FormCheckbox
                                        name="overrideWorkColumnsQuery"
                                        checked={
                                            typeof config.overrideWorkColumnsQuery !== 'undefined'
                                                ? config.overrideWorkColumnsQuery
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Override Work Columns Query')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    {config.overrideWorkColumnsQuery && (
                                        <div>
                                            <CodeMirror
                                                id="config.customWorkColumnsQuery"
                                                value={config.customWorkColumnsQuery}
                                                onChange={value =>
                                                    this.handleValidation({
                                                        target: {
                                                            value,
                                                            name: 'config.customWorkColumnsQuery'
                                                        }
                                                    })
                                                }
                                                options={{
                                                    mode: 'pipes',
                                                    matchBrackets: true,
                                                    lineNumbers: true,
                                                    foldGutter: true
                                                }}
                                            />
                                        </div>
                                    )}
                                    <FormCheckbox
                                        name="overrideCasingFluidsQuery"
                                        checked={
                                            typeof config.overrideCasingFluidsQuery !== 'undefined'
                                                ? config.overrideCasingFluidsQuery
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n('Override Casing Fluids Query')}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    {config.overrideCasingFluidsQuery && (
                                        <div>
                                            <CodeMirror
                                                id="config.customCasingFluidsQuery"
                                                value={config.customCasingFluidsQuery}
                                                onChange={value =>
                                                    this.handleValidation({
                                                        target: {
                                                            value,
                                                            name: 'config.customCasingFluidsQuery'
                                                        }
                                                    })
                                                }
                                                options={{
                                                    mode: 'pipes',
                                                    matchBrackets: true,
                                                    lineNumbers: true,
                                                    foldGutter: true
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </Panel.Body>
                        </Panel>
                        {config.integrationSystem === 'ADNOCEDM' && (
                            <Panel eventKey="6">
                                <Panel.Heading>
                                    <Panel.Title toggle>
                                        <h3>EDM Cache Settings</h3>
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body collapsible>
                                    <FormGroup
                                        type="text"
                                        label={
                                            <span>
                                                {' '}
                                                {i18n('EDM Expire After Access (seconds)')}
                                                <abbr title="required">*</abbr>
                                            </span>
                                        }
                                        name="config.edmExpireAfterAccess"
                                        value={config.edmExpireAfterAccess}
                                        onChange={this.handleValidation}
                                        validationState={this.validationState('config.edmExpireAfterAccess')}
                                        hasFeedback
                                        help={this.errorsFor('config.edmExpireAfterAccess')}
                                    />
                                    <FormGroup
                                        type="text"
                                        label={
                                            <span>
                                                {' '}
                                                {i18n('EDM Maximum Cache Size')}
                                                <abbr title="required">*</abbr>
                                            </span>
                                        }
                                        name="config.edmMaximumCacheSize"
                                        value={config.edmMaximumCacheSize}
                                        onChange={this.handleValidation}
                                        validationState={this.validationState('config.edmMaximumCacheSize')}
                                        hasFeedback
                                        help={this.errorsFor('config.edmMaximumCacheSize')}
                                    />
                                </Panel.Body>
                            </Panel>
                        )}
                        <Panel eventKey={'7'}>
                            <Panel.Heading>
                                <Panel.Title toggle>
                                    <h3>Misc Settings</h3>
                                </Panel.Title>
                                <Panel.Body collapsible>
                                    <div>
                                        <FormGroup
                                            type="text"
                                            label={<span> {i18n('Timezone Offset')}</span>}
                                            name="config.timezoneOffset"
                                            value={config.timezoneOffset}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.timezoneOffset')}
                                            hasFeedback
                                            help={this.errorsFor('config.timezoneOffset')}
                                        />
                                        <FormGroup
                                            type="text"
                                            label={<span> {i18n('Core Pool Size')}</span>}
                                            name="config.corePoolSize"
                                            value={config.corePoolSize}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.corePoolSize')}
                                            hasFeedback
                                            help={this.errorsFor('config.corePoolSize')}
                                        />
                                        <FormGroup
                                            type="text"
                                            label={<span> {i18n('Maximum Pool Size')}</span>}
                                            name="config.maximumPoolSize"
                                            value={config.maximumPoolSize}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.maximumPoolSize')}
                                            hasFeedback
                                            help={this.errorsFor('config.maximumPoolSize')}
                                        />
                                        <FormCheckbox
                                            name="manageChangeLog"
                                            checked={
                                                typeof config.manageChangeLog !== 'undefined'
                                                    ? config.manageChangeLog
                                                    : false
                                            }
                                            onChange={this.onChangeCheckbox}
                                            description={i18n(
                                                'Allow Plugin to Freeze Intervention/Parameter settings (Manage Change Logs)'
                                            )}
                                            disabled={undefined}
                                            note={undefined}
                                        />
                                        <FormCheckbox
                                            name="useInterventionSections"
                                            checked={
                                                typeof config.useInterventionSections !== 'undefined'
                                                    ? config.useInterventionSections
                                                    : false
                                            }
                                            onChange={this.onChangeCheckbox}
                                            description={i18n(
                                                'Use intervention sections data on navigation if available'
                                            )}
                                            disabled={undefined}
                                            note={undefined}
                                        />
                                    </div>
                                </Panel.Body>
                            </Panel.Heading>
                        </Panel>
                    </PanelGroup>
                </div>
            </FormBase>
        )
    }
})

export default Form

const StyledTableFormContainer = styled.div`
    .table-form {
        max-width: 80% !important;
    }
`
